const prefix = 'lumahealth/DialogSendOffers';

export const CLEAR_TAGS = `${prefix}/CLEAR_TAGS`;
export const CLEAR_WAITLISTS = `${prefix}/CLEAR_WAITLISTS`;

export const LOAD_APPOINTMENT_TYPES = `${prefix}/LOAD_APPOINTMENT_TYPES`;
export const LOAD_APPOINTMENT_TYPES_ERROR = `${prefix}/LOAD_APPOINTMENT_TYPES_ERROR`;
export const LOAD_APPOINTMENT_TYPES_SUCCESS = `${prefix}/LOAD_APPOINTMENT_TYPES_SUCCESS`;

export const LOAD_FACILITIES = `${prefix}/LOAD_FACILITIES`;
export const LOAD_FACILITIES_ERROR = `${prefix}/LOAD_FACILITIES_ERROR`;
export const LOAD_FACILITIES_SUCCESS = `${prefix}/LOAD_FACILITIES_SUCCESS`;

export const LOAD_PROVIDERS = `${prefix}/LOAD_PROVIDERS`;
export const LOAD_PROVIDERS_ERROR = `${prefix}/LOAD_PROVIDERS_ERROR`;
export const LOAD_PROVIDERS_SUCCESS = `${prefix}/LOAD_PROVIDERS_SUCCESS`;

export const LOAD_WAITLISTS = `${prefix}/LOAD_WAITLISTS`;
export const LOAD_WAITLISTS_ERROR = `${prefix}/LOAD_WAITLISTS_ERROR`;
export const LOAD_WAITLISTS_SUCCESS = `${prefix}/LOAD_WAITLISTS_SUCCESS`;

export const SEND_OFFER = `${prefix}/SEND_OFFER`;
export const SEND_OFFER_ERROR = `${prefix}/SEND_OFFER_ERROR`;
export const SEND_OFFER_SUCCESS = `${prefix}/SEND_OFFER_SUCCESS`;

export const LOAD_TAGS = `${prefix}/LOAD_TAGS`;
export const LOAD_TAGS_ERROR = `${prefix}/LOAD_TAGS_ERROR`;
export const LOAD_TAGS_SUCCESS = `${prefix}/LOAD_TAGS_SUCCESS`;

export const FORM_NAME = 'DialogSendOffersForm';

export const SELECT_PAGE_SIZE = 30;
